interface tabulatorCustomCellMenu
{
  id?:string;
  label?:string;
  icon?:string
  class?:string;
  onClick?:Function;
}
export function showCellMenu(e:any, cell:any, items:tabulatorCustomCellMenu[] = [], position = "left") {
  // remove any previous menu
  document.querySelectorAll(".tabulator-cell-menu").forEach(el => el.remove());
  e.stopPropagation();
  e.preventDefault();

  const rowEl = cell.getRow().getElement();
  rowEl.classList.add("menu-open-highlight"); // 👈 agrega clase highlight

  const menu = document.createElement("div");
  menu.className = "tabulator-cell-menu"
  menu.style.cssText =
    // pointer-events:auto es necesario porque cuando el menú se abre dentro de un UModal/UDrawer,
    // Reka UI pone document.body.style.pointerEvents="none" y solo reactiva "auto" en su propio
    // contenido; este menú se agrega directo a <body>, fuera de ese árbol, así que sin esto queda inerte al click.
    "position:fixed; left:0; top:0; visibility:hidden; z-index:2147483647; pointer-events:auto; background:#fff; border:1px solid #ccc; box-shadow:0 6px 18px rgba(0,0,0,0.12); min-width:180px; padding:6px 0; border-radius:6px; font-family:sans-serif; font-size:14px;";

  const margin = 6;

  items.forEach((it:tabulatorCustomCellMenu) => {
    if (it.class === "separator") {
      const separator = document.createElement("div");
      separator.style.cssText = "height:1px; background:#ddd; margin:4px 0;";
      menu.appendChild(separator);
    } else {
      const item = document.createElement("div");
      item.className = "tabulator-cell-menu-item " + it.class;
      item.style.cssText =
        "font-size:12px;display:flex; align-items:center; gap:8px; padding:6px 12px; cursor:pointer; user-select:none;";
      item.innerHTML = `${it.icon || ""}<span>${it.label || ""}</span>`;
      item.addEventListener("click", (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        if (typeof it.onClick === "function") it.onClick(cell.getRow().getData(), cell);
        cleanup();
      });
      menu.appendChild(item);
    }
  });

  document.body.appendChild(menu);

  // --- position ---
  const rect = cell.getElement().getBoundingClientRect();
  const menuRect = menu.getBoundingClientRect();
  let top = rect.bottom;
  let left = position === "right" ? rect.right - menuRect.width - (menuRect.width/11) : rect.left;

  if (left < margin) left = margin;
  if (left + menuRect.width > window.innerWidth - margin) left = window.innerWidth - menuRect.width - margin;
  if (top + menuRect.height > window.innerHeight - margin) top = rect.top - menuRect.height;

  menu.style.left = `${left}px`;
  menu.style.top = `${top}px`;
  menu.style.visibility = "visible";

  // --- close logic ---
  const outsideClickHandler = (ev:any) => { if (!menu.contains(ev.target)) cleanup(); };
  setTimeout(() => document.addEventListener("mousedown", outsideClickHandler), 0);

  const escHandler = (ev:any) => { if (ev.key === "Escape") cleanup(); };
  document.addEventListener("keydown", escHandler);

  const closeOnScroll = () => cleanup();
  window.addEventListener("scroll", closeOnScroll, true);
  window.addEventListener("resize", closeOnScroll);

  function cleanup() {
    menu.remove();
    rowEl.classList.remove("menu-open-highlight"); // 👈 quita highlight
    document.removeEventListener("mousedown", outsideClickHandler);
    document.removeEventListener("keydown", escHandler);
    window.removeEventListener("scroll", closeOnScroll, true);
    window.removeEventListener("resize", closeOnScroll);
  }
}
